import "./Programs.module.css";
import Header from "@/reusable_sections/Header";
import Overview from "./sections/Overview";
import Classroom from "./sections/Classroom";
import Trial from "./sections/Trial";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
import Showcase from "./sections/Showcase";
import ProgramEcosystem from "./sections/ProgramEcosystem";
import PathwayComparison from "./sections/PathwayComparison";
export default function ProgramsPage() {
  return <div>
      <Header />
      <Overview />
      <ProgramEcosystem />
      <PathwayComparison />
      <Showcase />
      <Classroom />
      <Trial />
      <Consultation />
      <Footer />
    </div>;
}